import { Typography, TypographyProps } from "src/components-mui/base/typography/typography";
import { IFractionDigits } from "src/hooks/formatters/number-formatter";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { getPerformanceColor } from "src/utils/color-util";
import { isNullOrUndefined } from "src/utils/common-util";
import { formatNullable } from "src/utils/format/format-nullable/format-nullable";
import { toSxArray } from "src/utils/mui/sx/sx";

interface IPerformanceValueProps extends Omit<TypographyProps, "children"> {
    value: number | null;
    fractionDigits?: IFractionDigits;
}

export const PerformanceValue = ({ value, fractionDigits = 1, sx, ...typographyProps }: IPerformanceValueProps) => {
    const { formatPerformance } = useNumberFormatter();
    const formattedValue = formatNullable({ value, format: performance => formatPerformance(performance, fractionDigits) });
    const color = isNullOrUndefined(value) ? undefined : getPerformanceColor(formattedValue);

    return (
        <Typography component="span" {...typographyProps} sx={[{ color }, ...toSxArray(sx)]}>
            {formattedValue}
        </Typography>
    );
};
